import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import firebase from 'firebase'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({
    key: 'vue-gauth',
    paths: ['userInfo'],
    storage: window.sessionStorage
  })],
  state: {
    userInfo: {},
    uid: '',
    classInfo: []
  },
  mutations: {
    setUserInfo: function (state, userInfo) {
      state.userInfo = userInfo
    },
    setUserId: function (state, userId) {
      state.uid = userId
    },
    pushClassData: function (state, data) {
      const cData = data.data
      const key = data.key
      cData.key = key
      state.classInfo.push(cData)
      console.log('added to list')
    },
    removeClass: function (state, key) {
      const db = firebase.database()
      const ref = db.ref('class/' + state.uid)
      const hopperRef = ref.child(key)
      hopperRef.remove()
      console.log('remove')
    },
    updateAlready: function (state, data) {
      for (const c of state.classInfo) {
        if (c.id === data.id) {
          const db = firebase.database()
          const ref = db.ref('class/' + state.uid)
          const hopperRef = ref.child(c.key)
          hopperRef.update({
            already: data.already
          })
          console.log('already')
        }
      }
    },
    updateMember: function (state, data) {
      for (const c of state.classInfo) {
        if (c.id === data.id) {
          if (!data.already) {
            data.already = []
          }
          const db = firebase.database()
          const ref = db.ref('class/' + state.uid)
          const hopperRef = ref.child(c.key)
          hopperRef.update({
            mem: data.mem,
            already: data.already
          })
          console.log('member and already')
        }
      }
    }
  },
  actions: {
  }
})
